export default function(state = { console: {} }, action) {
  switch (action.type) {
    default:
      return state;
  }
}
